export default "__VITE_ASSET__CxuC8L51__"